import React from 'react'
import { IconMaps } from '@ow/icons'

const CheckedIcon = () => {
  return (
    <div
      style={{
        display: 'inline-block',
        marginRight: '-10px',
        marginTop: '-3px',
      }}
    >
      <IconMaps type="checkCircle" fill="green" />
    </div>
  )
}

export default CheckedIcon
